import Api from '@/common/api'
import { getUrl } from '@/common/helper'

export const authentication = {
  state: {
    lname: '',
    fname: '',
    lastLogin: '',
    token: '',
    status: '',
    l0: [],
    l1: [],
    l2: [],
    apr: false
  },
  actions: {
    login (context, payload) {
      return new Promise((resolve, reject) => {
        Api(true)
          .post(getUrl('core', 'authentication/request-token'), payload)
          .then(response => {
            let data = response.data

            // Check if 2FA setup is required
            if (data.Requires2FASetup || data.requires2FASetup) {
              localStorage.setItem('2fa_setup_token', data.SetupToken || data.setupToken)
              localStorage.setItem('2fa_email', payload.Username)
              resolve({ requires2FASetup: true, setupToken: data.SetupToken || data.setupToken })
              return
            }

            // Check if 2FA verification is required
            if (data.Requires2FA || data.requires2FA) {
              localStorage.setItem('2fa_challenge', JSON.stringify(data))
              localStorage.setItem('2fa_email', payload.Username)
              resolve({ requires2FA: true, challengeData: data })
              return
            }

            // Normal login - no 2FA required
            let accessToken = data.accessToken || data
            context.commit('authSuccess', accessToken)
            if (data.refreshToken) {
              localStorage.setItem('refreshToken', data.refreshToken)
            }
            localStorage.setItem('uname', payload.Username)
            resolve(response)
          })
          .catch((error) => {
            delete Api().defaults.headers.common['Authorization']
            context.commit('authError')
            reject(error)
          })
      })
    },
    logout (context) {
      return new Promise((resolve, reject) => {
        delete Api().defaults.headers.common['Authorization']
        context.commit('authError')
        resolve()
      })
    }
  },
  mutations: {
    authSuccess (state, token) {
      state.token = token
      state.status = 'success'
      localStorage.setItem('token', token)
    },
    authError (state) {
      state.token = ''
      state.status = 'error'
      // state.username = ''
      localStorage.removeItem('token')
      localStorage.removeItem('refreshToken')
      localStorage.removeItem('fname')
      localStorage.removeItem('lname')
      localStorage.removeItem('lastLogin')
      localStorage.removeItem('l1')
      localStorage.removeItem('l2')
      localStorage.removeItem('l3')
      localStorage.removeItem('uname')
      localStorage.removeItem('apr')
      localStorage.removeItem('accessInformation')
    },
    authLogout (state) {
      state.token = ''
      localStorage.removeItem('token')
      localStorage.removeItem('refreshToken')
      localStorage.removeItem('fname')
      localStorage.removeItem('lname')
      localStorage.removeItem('lastLogin')
      localStorage.removeItem('l1')
      localStorage.removeItem('l2')
      localStorage.removeItem('l3')
      localStorage.removeItem('uname')
      localStorage.removeItem('apr')
      localStorage.removeItem('accessInformation')
    },
    authUserLname (state, lname) {
      state.lname = lname
      localStorage.setItem('lname', lname)
    },
    authUserFname (state, fname) {
      state.fname = fname
      localStorage.setItem('fname', fname)
    },
    authLastLogin (state, lastLogin) {
      state.lastLogin = lastLogin
      localStorage.setItem('lastLogin', lastLogin)
    },
    authMenus (state, menus) {
      state.l0 = menus
      localStorage.setItem('l0', menus)
    },
    authModules (state, modules) {
      state.l1 = modules
      localStorage.setItem('l1', modules)
    },
    authCategories (state, categories) {
      state.l2 = categories
      localStorage.setItem('l2', categories)
    },
    authApr (state, apr) {
      state.apr = apr
      localStorage.setItem('apr', apr)
    },
    authInformation (state, accessInformation) {
      state.accessInformation = accessInformation
      localStorage.setItem('accessInformation', accessInformation)
    }
  }
  // ,
  // getters: {
  //   authUsername: state => state.username,
  //   isAuthenticated: state => {
  //     return state.status === true && state.token !== ''
  //   }
  // }
}
